import React from 'react';
import cs from 'classnames';
import DocumentTitle from 'react-document-title';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import {push as pushPath} from 'react-router-redux';

import {getResource} from '~/misc/resourceId';
import * as urls from '~/routing/urls';
import {getBrokerName, getBrokerDescName, resource} from '~/misc/brokers';
import mapDispatch from '~/misc/mapDispatch';

import sharedCSS from '../shared.css';
import css from './index.css';

const navigate = (props, e) => {
  e.preventDefault();
  return pushPath(e.currentTarget.getAttribute('href'));
};

const BrokerItem = ({DOT, brokersData, view}) => {
  const descName = getBrokerDescName(brokersData, DOT);
  const url = `${urls.BROKERS}/${DOT}`;
  return (<a className={css.brokerItem} href={url} onClick={view}>
    <span className={css.codeName}>{DOT}</span>{' '}
    <span className={css.link}>

      {getBrokerName(brokersData, DOT)}
      {descName ? <span className={css.descName}>{descName}</span> : null}
    </span>
  </a>);
};

const BrokersCatalog = ({brokersData, view}) => (
  <div className={cs(sharedCSS.wideStretchable, sharedCSS.box, css.page)}>
    <DocumentTitle title={'Find brokers to haul loads from - Truckloads'}/>
    <Helmet>
      <meta
        name='description'
        content={'Find brokers to haul loads from'}
      />
    </Helmet>
    <h1 className={css.header}>Find brokers to haul loads from</h1>
    <div className={css.list}>
      {
        brokersData && brokersData.sorted
          .map(DOT => <BrokerItem key={DOT} DOT={DOT} brokersData={brokersData} view={view}/>)
      }
    </div>

  </div>
);

export default connect((state) => {
  const data = getResource(state, resource);
  return {
    brokersData: (data && data.item) || null,
  };
}, mapDispatch({
  view: navigate,
}))(BrokersCatalog);



// WEBPACK FOOTER //
// ./src/components/BrokersCatalog/index.js